import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { CustomerItem } from './customer-item';
import { StorageCurrentContextService } from '../../core/storage-current-context.service';

@Injectable({
  providedIn: 'root',
})
export class CustomerSelectorService {
  private selectedCustomerSubject = new BehaviorSubject<CustomerItem | null>(null);
  public selectedCustomer$: Observable<CustomerItem | null> = this.selectedCustomerSubject.asObservable();

  constructor(private readonly currentContextService: StorageCurrentContextService) {}

  public setSelectedCustomer(customer: CustomerItem | null): void {
    this.currentContextService.createOrUpdate({ selectedCustomerId: customer?.id ?? null });
    this.selectedCustomerSubject.next(customer);
  }

  public setCurrentSiteId(siteId: number): void {
    this.currentContextService.createOrUpdate({ currentSiteId: siteId });
  }

  public getCurrentCustomer(): CustomerItem | null {
    return this.selectedCustomerSubject.value;
  }

  public getStoredCustomerId(): string | null {
    return this.currentContextService.get()?.selectedCustomerId || null;
  }
}
